// Browser-chrome shortcuts to suppress app-wide (history, bookmarks, save-page, etc.)
// so they never interrupt POS/checkout keyboard flows.
//
// Kept intentionally narrow — only combos that open actual browser chrome/UI.
// Anything already claimed by an app shortcut (Ctrl+B, Ctrl+M, Ctrl+Enter, Ctrl+1/2/3,
// Ctrl+Left/Right, Ctrl+Shift+M) or standard text-editing (Ctrl+C/V/X/A/Z/F) must NOT
// appear here.
export const BLOCKED_BROWSER_SHORTCUTS = [
  { ctrl: true, key: 'h', label: 'Ctrl+H', description: 'Browser History' },
  { ctrl: true, key: 'd', label: 'Ctrl+D', description: 'Bookmark this page' },
  { ctrl: true, shift: true, key: 'd', label: 'Ctrl+Shift+D', description: 'Bookmark all tabs' },
  { ctrl: true, shift: true, key: 'b', label: 'Ctrl+Shift+B', description: 'Toggle bookmarks bar' },
  { ctrl: true, key: 's', label: 'Ctrl+S', description: 'Save page' },
  { ctrl: true, key: 'p', label: 'Ctrl+P', description: 'Browser print dialog (app has its own print flow)' },
  { ctrl: true, key: 'u', label: 'Ctrl+U', description: 'View page source' },
  { ctrl: true, key: 'o', label: 'Ctrl+O', description: 'Open file' },
  { ctrl: true, key: 'j', label: 'Ctrl+J', description: 'Downloads' },
  { ctrl: false, alt: false, shift: false, key: 'F1', label: 'F1', description: 'Browser/OS help' },
];

// True if keydown event e matches shortcut definition def.
// Only modifiers explicitly listed on def are checked (undefined = "don't care").
// ctrlKey/metaKey are treated as equivalent so Cmd works the same as Ctrl on Mac.
export function matches(e, def) {
  if (e.key.toLowerCase() !== def.key.toLowerCase()) return false;
  const ctrlOrMeta = e.ctrlKey || e.metaKey;
  if (def.ctrl !== undefined && ctrlOrMeta !== def.ctrl) return false;
  if (def.shift !== undefined && e.shiftKey !== def.shift) return false;
  if (def.alt !== undefined && e.altKey !== def.alt) return false;
  return true;
}
